export default ({ imgParams, i18n, pathfinder }) => {
  const _i18n = i18n.pages.AccessibilityPolicy;

  return { markdown: _i18n.MARKDOWN };
};
